import React from 'react';

const steps = [
  { n: '01', title: 'Audit IA', desc: "Analyse de votre situation actuelle et identification des opportunités à fort impact." },
  { n: '02', title: 'Stratégie', desc: "Co-construction d'une feuille de route IA alignée sur vos objectifs business." },
  { n: '03', title: 'Développement', desc: "Conception et intégration des solutions IA dans vos systèmes existants." },
  { n: '04', title: 'Déploiement', desc: "Lancement, suivi des performances et formation de vos équipes en continu." },
];

const whyUs = [
  { icon: '⚡', title: 'Expertise IA de pointe', desc: "Une équipe spécialisée dans les dernières technologies d'IA générative et d'automatisation." },
  { icon: '🎯', title: 'Sur-mesure à 100%', desc: "Chaque solution est conçue spécifiquement pour vos besoins et votre secteur d'activité." },
  { icon: '📈', title: 'ROI mesurable', desc: "Des KPIs clairs définis en amont pour mesurer l'impact réel de chaque solution déployée." },
  { icon: '🛡️', title: 'Accompagnement continu', desc: "Nous restons à vos côtés bien après le déploiement pour optimiser et faire évoluer vos solutions." },
];

export default function Process() {
  return (
    <>
      <section className="section" id="processus" style={{ background: 'linear-gradient(180deg, transparent, rgba(123,47,247,.05), transparent)' }}>
        <div className="section-header center">
          <span className="section-label">Notre méthode</span>
          <h2 className="section-title">Comment travaillons-nous ?</h2>
          <p className="section-sub">Un processus éprouvé en 4 étapes pour garantir le succès de votre projet IA.</p>
        </div>
        <div className="process-grid">
          {steps.map((s) => (
            <div className="process-step" key={s.n}>
              <div className="process-num">{s.n}</div>
              <h4>{s.title}</h4>
              <p>{s.desc}</p>
            </div>
          ))}
        </div>
      </section>

      <section className="section">
        <div className="section-header">
          <span className="section-label">Pourquoi nous</span>
          <h2 className="section-title">
            {"L'IA, c'est notre"} <span className="g-text">obsession</span>
          </h2>
          <p className="section-sub">Ce qui nous distingue et fait de Geek AI le partenaire idéal de votre transformation.</p>
        </div>
        <div className="why-grid">
          {whyUs.map((w) => (
            <div className="why-card" key={w.title}>
              <div className="why-icon">{w.icon}</div>
              <h4>{w.title}</h4>
              <p>{w.desc}</p>
            </div>
          ))}
        </div>
      </section>
    </>
  );
}
